import { useAxiosInstance } from '@gov-nx/api/axios';
import { usePoMutation } from '@gov-nx/api/hooks/usePoMutation';
import { saveDataBoxAllAttachmentsToDocumentsQuery } from '@gov-nx/api/queries/dataBoxQuery';
import { useMessageEvents } from '@gov-nx/core/events/Message/useMessageEvents';
import { useLocale } from '@gov-nx/core/service/translations/useLocale';
import { isFulfilled, isRejected } from '@gov-nx/core/types/promises';
import { PageCode } from '@gov-nx/module/page/definitions/codes';

export interface SaveAttachmentToDocumentsProps {
	onError: () => void;
	onSuccess: () => void;
}

export const useSaveAllAttachmentsToDocuments = ({
	onSuccess,
	onError,
}: SaveAttachmentToDocumentsProps) => {
	const { t: tn } = useLocale(PageCode['datove-schranky']);
	const { axiosInstance } = useAxiosInstance();

	const { toastMessageError, toastMessageSuccess } = useMessageEvents();

	const saveAllAttachmentsToDocuments = usePoMutation({
		mutationFn: saveDataBoxAllAttachmentsToDocumentsQuery(axiosInstance),
		onSuccess: (data) => {
			const successCount = data.filter(isFulfilled).length;
			const errorResponses = data.filter(isRejected);

			if (successCount || !errorResponses.length) {
				onSuccess?.();
			} else {
				onError?.();
			}

			if (errorResponses.length) {
				let errorMessage = '';

				const errorExtDesc =
					errorResponses[0].reason?.response?.data?.chyby?.[0]?.extPopis;
				const errorDesc =
					errorResponses[0].reason?.response?.data?.chyby?.[0]?.popis;

				if (errorExtDesc) {
					errorMessage = errorExtDesc;
				} else if (errorDesc) {
					errorMessage = errorDesc;
				} else {
					errorMessage = tn('akce.prilohy-ulozeny', { count: successCount });
				}

				toastMessageError(errorMessage);
			} else {
				toastMessageSuccess(
					successCount === 1
						? tn('akce.priloha-ulozena')
						: tn('akce.prilohy-ulozeny', { count: successCount })
				);
			}
		},
	});
	return saveAllAttachmentsToDocuments;
};
